module.exports = __webpack_public_path__ + "static/media/add.b05c0752.svg";